import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal, openModal } from 'redux/modules/modalLayout';
import * as styles from './ModalLayout.scss';
var ModalLayout = (_dec = connect(function (state) {
  return {
    organization: state.organization.current
  };
}, {
  closeModal: closeModal,
  openModal: openModal
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ModalLayout, _Component);

  var _super = _createSuper(ModalLayout);

  function ModalLayout() {
    _classCallCheck(this, ModalLayout);

    return _super.apply(this, arguments);
  }

  _createClass(ModalLayout, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      this.props.openModal();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.closeModal();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          organization = _this$props.organization,
          style = _this$props.style;
      return /*#__PURE__*/React.createElement("div", {
        id: "ModalLayout",
        style: style,
        className: styles.layout
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.childrenWrap,
        style: this.props.childrenWrapStyle
      }, children));
    }
  }]);

  return ModalLayout;
}(Component), _defineProperty(_class2, "propTypes", {
  children: PropTypes.node.isRequired,
  childrenWrapStyle: PropTypes.object,
  organization: PropTypes.object.isRequired
}), _defineProperty(_class2, "defaultProps", {
  childrenWrapStyle: {}
}), _temp)) || _class);
export default ModalLayout;